import React from 'react'
import { FormattedMessage } from 'react-intl'
import AppId from './appId'

export const API_BASE_URL = 'https://api.inon.vn'
export const RESOURCE_URL = 'https://sit2.inon.vn/resources/images/'
export const DIVAY_URL = 'https://admin.divay.vn/'
// export const API_BASE_URL = 'https://apidev.inon.vn'
export const API_LOGIN_URL = '/api/authenticate'
export const API_DIVAY_LOGIN_URL = '/api/divay-authenticate'
export const API_LOGOUT_URL = '/api/logout'
export const API_CHANGE_PASSWORD = '/api/change-password'
export const API_REGISTER = '/nth/onboarding/api/authenticate/register'
export const API_GET_USER = '/nth/user/api/users'
export const API_USER_SETTINGS = '/nth/user/api/user-settings'
export const API_UPDATE_USER_INFO = '/nth/user/api/update-user-info'
export const API_GET_NAV_CONFIGS = '/nth/accesscontrol/api/roles'
export const API_GET_USER_ROLES = '/nth/accesscontrol/api/user-group-roles'
export const API_CREATE_PASSWORD =
  '/nth/onboarding/api/authenticate/create-new-password'
export const API_GET_USER_BY_REGISTER_TOKEN =
  '/nth/onboarding/api/authenticate/get-partner'
export const API_COMPLETE_INFO =
  '/nth/onboarding/api/authenticate/complete-info'
export const API_FORGOT_PASSWORD = '/api/authenticate/forgot-password'
export const API_RESET_PASSWORD = '/api/authenticate/reset-password'
export const API_EMAIL_SUGGESTION =
  '/nth/user/api/authenticate/email-suggestion'
export const API_R_200 = 200

export const API_GET_CITIES_BY_COUNTRY =
  '/nth/datacollection/api/citiesbycountry'
export const API_GET_DISTRICTS_BY_CITY =
  '/nth/datacollection/api/districtsbycity'
export const API_GET_WARDS_BY_CITY = '/nth/datacollection/api/wardsbydistrict'
export const API_GET_BANKS = '/nth/datacollection/api/allBanks'

export const API_UPLOAD_FILE = '/nth/file/api/upload'
export const API_GET_FILE = '/nth/file/api/file'

export const MAX_MOBILE_WIDTH = 768
export const MAX_TABLET_WIDTH = 1024
export const REMEMBER_ME_TOKEN = 'rememberMe'

export const VN_COUNTRY_CODE = 192

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])((?=.*[0-9])|(?=.*[!@#$%^&*])).{8,}$/gm
export const PHONE_REGEX =  /^\b(84|0[3|5|7|8|9])+([0-9]{8})\b$/g
export const PERSONAL_ID_REGEX = /^(\d{9}|\d{12})$/
export const CITIZEN_INDENTIFY_REGEX = /^(\d{12})$/
export const PASSPORT_REGEX = /^(?!^0+$)[a-zA-Z0-9]{3,20}$/
export const NAME_REGEX = /^([ÀÁÂÃÈÉÊẾÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêếềìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹý0-9A-Za-z_. ])+$/g


export const AUTHORITIES = {
   VIEW : 'view', 
   EDIT : 'edit',
   APPROVE : 'approve',
   CREATE : 'create',
}

export const API_TIME_OUT = 70000;

export const MAX_FILE_SIZE = 5; // MB

export const CONTACT_PHONE = '02437.630.999'

export const SESSION_TIMEOUT = 30 // mins

export const DATE_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss'

export const LOGIN_STATUS = {
  SUCCESS: 'SUCCESS',
  FAIL: 'FAIL'
}

export const USER_TYPE = {
  KD: 'KD',
  HTKD: 'HTKD'
}

export const GENDER_OPTIONS = [
  { value: 'MALE', label: <FormattedMessage id='common.gender.male' /> },
  { value: 'FEMALE', label: <FormattedMessage id='common.gender.female' /> },
  { value: 'OTHERS', label: <FormattedMessage id='common.gender.other' /> }
]

export const IC_TYPES_OPTIONS = [
  { value: 'HC', label: <FormattedMessage id='common.icType.passport' /> },
  {
    value: 'CMND',
    label: <FormattedMessage id='common.icType.personalID' />
  },
  {
    value: 'CCCD',
    label: <FormattedMessage id='common.icType.citizenIdentify' />
  }
]


export const getExternalAppUrl = (appId, url) => {
  switch (appId) {
    case AppId.APP_NO1:
    case AppId.DIVAY_APP:
      return `${window.location.origin}/${url}?redirectUrl=${url}`
    case AppId.INSURANCE_APP:
    case AppId.DIVAY_INSURANCE_APP:
      return `${window.location.origin}/insurance${url}?redirectUrl=${url}`
    case AppId.SUPPLEMENT_APP:
    case AppId.DIVAY_SUPPLEMENT_APP:
      return `${window.location.origin}/supplement${url}?redirectUrl=${url}`
    case AppId.ELITE_APP:
      return `${window.location.origin}/elite${url}?redirectUrl=${url}`
  }
}


export const getContextPath = (appId) => {
  switch (appId) {
    case AppId.APP_NO1:
    case AppId.DIVAY_APP:
      return ''
    case AppId.INSURANCE_APP:
    case AppId.DIVAY_INSURANCE_APP:
      return 'insurance'
    case AppId.SUPPLEMENT_APP:
    case AppId.DIVAY_SUPPLEMENT_APP:
      return 'supplement'
    case AppId.ELITE_APP:
      return 'elite'
  }
}

export const getPropObject = (obj, prop) => {
  if (!obj) {
    return null
  }
  return prop.split('.').reduce((r, e) => {
    return r ? r[e] : null
  }, obj)
}


export const USER_ROLE = {
  ADMIN: 'AD.IO',
  KD: 'KD.IO',
  HTKD: 'HTKD.IO',
  KT: 'KT.IO',
  VH: 'VH.IO',
  DTL1: 'L1.DT',
  DTL2: 'L2.DT',
  DTL3: 'L3.DT',
  DTL4: 'L4.DT',
  DTL5: 'L5.DT',
  DTLX: 'LX.DT',
  BH: 'BH',
  BTBH: 'BTBH',
  HTDT: 'HT.DT'
}

export const IMAGE = {
  LOGO: RESOURCE_URL + 'divay-logo-v.svg',
  LOGO_NO_TEXT: RESOURCE_URL + 'divay-logo-no-text.svg',
  LOGO_TEXT: RESOURCE_URL + 'divay-logo-text.svg',
  NAV_ICON_1: RESOURCE_URL + 'nav-plane-icon.svg',
  NAV_ICON_2: RESOURCE_URL + 'nav-bus-icon.svg',
  NAV_ICON_3: RESOURCE_URL + 'nav-people-icon.svg',
  NAV_ICON_4: RESOURCE_URL + 'nav-motorbike-icon.svg',
  NAV_ICON_5: RESOURCE_URL + 'nav-car-icon.svg',
  BUY_INSURANCE: RESOURCE_URL + 'divay-buy-insurance.svg',
  LOGO_WHITE: RESOURCE_URL + 'in-on-logo-white.svg',
  LANDING_PAGE_BG: RESOURCE_URL + 'lading-page-h.svg',
  LANDING_PAGE_2_BG: RESOURCE_URL + 'lading-page-2.svg',
  LANDING_PAGE_TABLET_BG: RESOURCE_URL + 'lading-page-v.svg',
  DOWNLOAD_APP_IOS: RESOURCE_URL + 'app-store.svg',
  DOWNLOAD_APP_ANDROID: RESOURCE_URL + 'google-store.svg',
}
